import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import {
  convertCelsiusToFahrenheit,
  getLocationsMachinesName,
} from 'shared/helpers/helpers';

const initialState = {
  commandsInfo: {
    8983061444921505: [],
    dav: [






























































































































































    ],
  },
  viewCommand: false,
  searchedCommand: { command: null, userId: null },
  commandNumber: Number('0'),
  commandDate: '',
  isNewCommandCreated: false,
  commandApplied: false,
  controllersStatus: [false, false, false, false, false],
  controlResetInitialState: false,
};

const DATE = moment().format('DDMMYY');

const mCCommandSlice = createSlice({
  name: 'mCCommand',
  initialState,
  reducers: {
    handleCreateCommand: (state, action) => {

      console.log(state,action,"state.commandsInfo")
      let totalCommands = 0;
      Object.values(state.commandsInfo).forEach((eachUserCommands) => {
        eachUserCommands.forEach((command) => {
          if (Object.keys(command)[0].split('-')[2] === DATE) {
            return totalCommands++;
          }
        });
      });



      state.isNewCommandCreated = true;


      state.controllersStatus = [...initialState.controllersStatus];

      if (DATE !== state.commandDate) {
        state.commandDate = DATE;
      }
    },
    handleResetCreateNewCommand: (state) => {
      state.isNewCommandCreated = false;
    },
    handleCommandNumber: (state, action) => {
      state.commandNumber = action.payload;
    },
    handleResetCommandNumber: (state, action) => {
      state.commandNumber = Number('0');
    },
    handleControllersStatus: (state, action) => {
      state.controllersStatus[action.payload] = true;
    },
    handleViewCommand: (state, action) => {
      state.viewCommand = action.payload;
    },
    handleSearchCommand: (state, action) => {
      state.searchedCommand = action.payload;
    },
    handleSaveCommand: (state, action) => {

      state.commandsInfo[action.payload.user].push(action.payload.commandData);
      state.isNewCommandCreated = false;
    },
    handleApplyCommand: (state, action) => {
      state.commandApplied = action.payload;
    },
    handleControlResetInit: (state, action) => {
      state.controlResetInitialState = action.payload;
    },
    handleCommandInfo: (state, action) => {
      const { data, user, isF, flatEssSwitch, flatTgsSwitch, flatTesSwitch } =
        action.payload;
      const newData = data?.map(({ row: item }) => {
        const date = moment(item.createdAt).format('DDMMYY');
        const commandKey = `mca-${user.user_code}-${date}-${
          item.newData.commandNumber || 0
        }`;
        const unit = isF ? 'F' : 'C';

        const system =
          item.deviceType === 'ESS'
            ? 'ess-typhoon electric system'
            : item.deviceType === 'TGS'
            ? 'tgs-typhoon gas system'
            : 'tes-typhoon gas system';

        const switches =
          item.deviceType === 'ESS'
            ? flatEssSwitch
            : item.deviceType === 'TGS'
            ? flatTgsSwitch
            : flatTesSwitch;

        const { locations, machines } = getLocationsMachinesName(
          item.deviceIds,
          switches
        );

        return {
          [commandKey]: {
            system,
            switches: item.deviceIds.length,
            locations,
            machines,
            ats:
              item.newData.EBP === 2
                ? { activateTgs: true, reactivate: false, block: false }
                : item.newData.EBP === 1
                ? { activateTgs: false, reactivate: false, block: true }
                : item.newData.EBP === 0
                ? { activateTgs: false, reactivate: true, block: false }
                : { activateTgs: false, reactivate: false, block: false },
            deactivate: {
              instantHeat: item.newData.on_switch === 0,
              isFanOnly: item.newData.fan === 0,
              heatingSchedule: !!item.newData.deleteCurrentSchedule,
              optionalConstantTemp: item.newData.on_constant === 0,
              snowSensor: item.newData.snow_enabled === 0,
              windFactor: item.newData.wind === 0,
            },
            isF,
            parameters: {
              instantHeat: item.newData.on_switch
                ? `active ${
                    isF
                      ? convertCelsiusToFahrenheit(item.newData.instant_temp)
                      : item.newData.instant_temp
                  }°${unit}`
                : null,
              optionalConstantTemp: item.newData.on_constant
                ? `ready ${
                    isF
                      ? convertCelsiusToFahrenheit(item.newData.constant_temp)
                      : item.newData.constant_temp
                  }°${unit}`
                : null,
              fanOnly: item.newData.fan ? 'ready' : null,
              snowSensor: item.newData.snow_enabled ? 'ready' : null,
              heatingSchedule: item.newData.schedule?.startDate
                ? `ready ${
                    isF
                      ? convertCelsiusToFahrenheit(
                          item.newData.schedule.threshold
                        )
                      : item.newData.schedule.threshold
                  }°${unit}` +
                  `|${item.newData.schedule.startDate}` +
                  `|${item.newData.schedule.endDate}`
                : null,
              windFactor: item.newData.wind ? 'ready' : null,
            },
          },
        };
      });

      state.commandsInfo[user.user_id] = newData;
    },
    handleCommandDate: (state, action) => {
      state.commandDate = action.payload;
    },
  },
});

export default mCCommandSlice;
export const selectMCCommand = (state) => state.mCCommand;
export const {
  handleCreateCommand,
  handleViewCommand,
  handleApplyCommand,
  handleSearchCommand,
  handleSaveCommand,

  handleControllersStatus,
  handleControlResetInit,
  handleCommandInfo,
  handleCommandNumber,
  handleResetCommandNumber,
  handleCommandDate,
  handleResetCreateNewCommand,
} = mCCommandSlice.actions;
